import { useMutation } from "@apollo/client/react";
import paths from "config/routePaths";
import Company from "domain/Company";
import { CreateCompany, GetAllCompanies } from "hooks/apollo/company/company.gql";
import useGoBack from "hooks/useGoBack";
import React from "react";
import Uuid from "utils/Uuid";
import CompanyEditView from "./CompanyEditView";

export default function CompanyEditContainer() {
  const { goBack } = useGoBack();

  const [createCompany] = useMutation(CreateCompany, { onCompleted: () => leavePage() });

  const handleCancel = () => leavePage();

  const handleSave = (args) => {
    const defaultCompany = {
      id: Uuid.generate(),
      name: "",
    };

    const company = { ...defaultCompany, ...args };

    return createCompany({ refetchQueries: [{ query: GetAllCompanies }], variables: company });
  };

  const leavePage = () => {
    goBack(paths.companyIndex);
  };

  return <CompanyEditView company={Company.build()} onCancel={handleCancel} onSave={handleSave} />;
}
